
















import { Component, Vue } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'
import { getModule } from 'vuex-module-decorators'
import Matrix from '@/store/modules/matrix'

getModule(Matrix)

@Component({
  computed: {
    ...mapGetters([
      'profile'
    ])
  },
  methods: {
    ...mapActions([
      'changeSelection'
    ])
  }
})
export default class Profile extends Vue {
}
